import React from 'react';
import { parse } from 'query-string';
import {List, Datagrid, TextField, ReferenceField, NumberField, BooleanField, DateField} from 'react-admin';
import {Create, SimpleForm, ReferenceInput, TextInput, SelectInput} from 'react-admin';

export const FirmwareJobList = props => {
  console.log(props);
  return (
    <>
      <List title='Hydrant Fleet Management - Firmware Job' bulkActionButtons={false} exporter={false} {...props}>
        <Datagrid isRowSelectable={()=>(false)}>
          <TextField label="Id" source="id" />
          {/* <TextField label="Firmware Id" source="firmwareId" /> */}
          <ReferenceField source='firmwareId' reference='firmwares'>
            <TextField source="version" />
          </ReferenceField>
          <NumberField label="Seq." source="sequenceNumber" format={v => v*100} parse={v => v/100}/>
          <TextField label="Device Id" source="deviceId" />
          <BooleanField label="Completed" source="isComplete"/>
          <DateField showTime label="Created" source="createdAt" />
        </Datagrid>
      </List>
    </>  
  );
};

export const FirmwareJobCreate = props => {
  console.log(parse(props.location.search));

  return (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput source="firmwareId" reference="firmwares">
              <SelectInput optionText="version" />
            </ReferenceInput>
            {/* <TextInput label='Firmware Id' source="firmwareId" /> */}
            <TextInput label='Device Ids (CSV)' source="deviceIds" initialValue={props.location.search} />          
            
        </SimpleForm>
    </Create>
  );
};

  
  